/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import 'moment/locale/es';

import { getUserBrowserLanguage } from '@ts-core/utils/languageUtils';
import { I18NProvider } from '@ts-core/lib/i18n';
import { SnackbarProvider } from '@ts-core/lib/snackbar';

import { createTheme } from 'core/theme';
import { createApolloClient } from 'core/utils/apollo';

import enMessages from '@ts-core/strings/en.json';
import esMessages from '@ts-core/strings/es.json';

import App from './App';

const currentLanguage = getUserBrowserLanguage();
const messages: Record<string, string> = currentLanguage === 'en' ? enMessages : esMessages;

// Theme
const theme = createTheme();

const apolloClient = createApolloClient();

const Application = (
  <I18NProvider language={currentLanguage} messages={messages}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={currentLanguage}>
          <ApolloProvider client={apolloClient}>
            <SnackbarProvider>
              <Router>
                <App />
              </Router>
            </SnackbarProvider>
          </ApolloProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </I18NProvider>
);

ReactDOM.render(Application, document.getElementById('root'));
